
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const BottomNav: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const navItems = [
    { path: '/home', icon: 'ri-home-line', activeIcon: 'ri-home-fill', label: t('home') },
    { path: '/hotels', icon: 'ri-hotel-line', activeIcon: 'ri-hotel-fill', label: t('hotels') },
    { path: '/flights', icon: 'ri-plane-line', activeIcon: 'ri-plane-fill', label: t('flights') },
    { path: '/my-trips', icon: 'ri-suitcase-line', activeIcon: 'ri-suitcase-fill', label: t('myTrips') },
    { path: '/profile', icon: 'ri-user-line', activeIcon: 'ri-user-fill', label: t('profile') }
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50">
      <div className="grid grid-cols-5 h-16">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`flex flex-col items-center justify-center space-y-1 transition-colors ${
                isActive ? 'text-blue-600' : 'text-gray-500'
              }`}
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className={`${isActive ? item.activeIcon : item.icon} text-xl`}></i>
              </div>
              <span className="text-xs font-medium">{item.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default BottomNav;
